export const Levels = [
  {
    "name": 1,
    "word": "сальмонельоз",
    "variabales": [
      "сльоза", "слалом", "солома", "сезон",
      "салон", "масло", "слон", "лось", "моль",
      "лоза", "сало", "зона", "зола", "льон", "соль",
      "лаз", "мол", "оса", "зал", "сом",
    ],
    "answers": [],
  },
  {
    "name": 2,
    "word": "хрестоматія",
    "variabales": [
      "тахометр", "матерія", "маестро", "сміттяр", "термос",
      "статор", "істота", "містер", "саміт", "хрест",
      "серія", "матір", "тісто", "місто", "тест",
      "море", "мрія", "яма", "ром", "сом",
    ],
    "answers": [],
  },
  {
    "name": 3,
    "word": "спустошення",
    "variabales": [
      "осушення", "шепотун", "ступня", "сушеня",
      "сонет", "сотня", "тонус", "сопун",
      "поет", "соус", "стоп", "степ", "шунт",
      "пес", "соя", "суп", "тон", "шоу",
    ],
    "answers": [],
  },
  {
    "name": 4,
    "word": "форамініфера",
    "variabales": [
      "ефіроман", "марафон", "реформа", "амфора", "манера",
      "морфін", "фанера", "фараон", "ферма", "німфа",
      "афіна", "номер", "форма", "арфа", "море",
      "омар", "рама", "фора", "ера", "міф",
    ],
    "answers": [],
  },
  {
    "name": 5,
    "word": "україночка",
    "variabales": [
      "українка", "конурка", "курочка", "кокаїн", "країна",
      "крона", "круча", "онука", "ранок", "чарка",
      "арка", "кнур", "кора", "кран", "куча",
      "орк", "рак", "рок", "чан", "чар",
    ],
    "answers": [],
  }
]

export const Helper = [
  ["сльоза", "Безбарвна прозора солонувата рідина, яку виділяють розміщені в очній ямці залози при деяких фізіологічних або психічних станах."],
  ["сезон", "Одна з чотирьох пір року."],
  ["масло", "Харчовий продукт, який виробляють збиванням вершків або сметани."],
  ["лось", "Велика тварина родини оленячих з лопатоподібними рогами у самців."],
  ["моль", "Скорочена назва грам-молекули."],
  ["лоза", "Народна назва деяких кущових порід верби."],
  ["сало", "Жирове відкладення у тілі живого організму."],
  ["зона", "Певний простір, район, територія, що характеризуються спільними ознаками."],
  ["зола", "Незгорілі мінеральні рештки у вигляді пилу, що лишаються після спалювання якої-небудь речовини."],
  ["льон", "Однорічна або багаторічна трав'яниста технічна рослина, з стебел якої виготовляють волокно, а з насіння - олію."],
  ["лаз", "Вузький отвір, через який можна пролізти, пройти куди-небудь."],
  ["мол", "Захисна споруда в порту у вигляді стіни або дамби, що виступають у море."],
  ["оса", "Чорна з жовтими поперечними смужками перетинчастокрила комаха, що жалить, як бджола."],
  ["зал", "Велике приміщення для багатолюдних зборів, засідань, занять і т. ін."],
  ["сом", "Велика прісноводна хижа безлуска риба родини сомових з кількома парами вусів."],
  ["слалом", "Вид лижного спорту - швидкісний спуск з гір на лижах за звивистим маршрутом, який позначається контрольними віхами, прапорцями."],
  ["солома", "Сухі світло-жовті стебла злакових рослин, що залишаються після обмолоту і які використовують як корм скотині, паливо, а також для підстилки, покриття будівель"],
  ["салон", "Парадний зал або простора кімната для приймання гостей в аристократичних і буржуазних домах."],
  ["соль", "П'ятий звук музичної гами, а також нота, що позначає цей звук."],
  ["слон", "Великий травоїдний ссавець з довгим хоботом і двома бивнями, що живе в тропічній Африці та Азії."],
  ["тахометр", "Прилад для вимірювання кутової швидкості обертового тіла."],
  ["матерія", "Об'єктивна реальність, що існує поза людською свідомістю й незалежно від неї."],
  ["маестро", "Шаноблива назва видатного музиканта, композитора, художника."],
  ["сміттяр", "Той, хто займається прибиранням та вивезенням сміття."],
  ["термос", "Посудина з подвійними скляними стінками всередині, яка запобігає охолодженню або нагріванню поміщеного в ній продукту."],
  ["статор", "Нерухома частина електричних машин (генератора, двигуна і т. ін.), що взаємодіє з обертовою частиною - ротором."],
  ["істота", "Живий організм; людина, тварина."],
  ["містер", "Ввічлива назва мужчини в англійців і американців, що вживається звичайно перед прізвищем або ім'ям."],
  ["саміт", "Зустріч глав держав або голів урядів з потужним освітленням в засобах масовоï інформаціï, підвищеними заходами безпеки та узгодженим попередньо порядком денним."],
  ["хрест", "Предмет і символ культу християнської релігії, який являє собою стрижень з однією або кількома поперечками у верхній половині (за євангельською легендою, на стовпі з перехрестям був розіп'ятий Христос)."],
  ["серія", "Ряд однорідних або споріднених за спільною ознакою предметів."],
  ["матір", "Жінка стосовно дитини, яку вона народила."],
  ["тісто", "В'язка маса різної густоти з борошна, замішаного на воді, молоці і т. ін. часто з додаванням дріжджів."],
  ["місто", "Великий населений пункт; адміністративний, промисловий, торговий і культурний центр."],
  ["тест", "Коротке стандартне завдання, метод випробування, що застосовується в різних галузях науки для одержання кількісної характеристики певних явищ."],
  ["море", "Частина океану - великий водний простір з гірко-солоною водою, який більш-менш оточений суходолом."],
  ["мрія", " Те, що створене уявою, фантазією; витвір уяви."],
  ["яма", "Заглиблення в землі. "],
  ["ром", "Міцний напій із соку, що перебродив, або з патоки тростинного цукру."],
  ["осушення", "Дія за знач. осушити."],
  ["шепотун", "Той, хто говорить шепотом."],
  ["ступня", "Нижня опорна частина ноги; стопа."],
  ["сушеня", "Те саме, що сушня"],
  ["сонет", "Віршована строфа, яка складається з 14 рядків, перев. п'ятистопного ямба - двох чотиривіршів та двох тривіршів."],
  ["сотня", "Одиниця рахунку однакових або однотипних предметів, явищ і т. ін., що дорівнює ста."],
  ["тонус", "Стан, коли тривале збудження нервової або м'язової тканини не супроводиться стомленням і зумовлює добре функціонування організму."],
  ["сопун", " Той, хто сопе, має звичку сопіти."],
  ["поет", "Автор літературних віршованих, прозових і драматичних поетичних творів."],
  ["соус", "Рідка приправа до страви."],
  ["стоп", "Уживається як команда для припинення руху."],
  ["степ", "Великий безлісий, вкритий трав'янистою рослинністю, рівнинний простір у зоні сухого клімату."],
  ["шунт", "Електричне або магнітне відгалуження, яке вмикають паралельно до основного кола, або відгалуження вимірювального приладу (гальванометра, амперметра) для відведення частини електричного струму чи магнітного потоку."],
  ["пес", "Те саме, що собака."],
  ["соя", "Трав'яниста однорічна рослина родини бобових, насіння якої використовують для виробництва харчових продуктів (молока, олії, крупи, борошна і т. ін.) та в техніці."],
  ["суп", " Рідка страва, яка являє собою перев. м'ясний, рибний або грибний відвар з овочами, крупами і т. ін."],
  ["тон", "Співвідношення двох звуків, що охоплюють 1/6 октави і є мірою для визначення розміру якісної величини інтервалу."],
  ["шоу", "Видовище, вистава; масове видовище за участю 'зірок' естради, цирку, спорту, джаз-оркестрів, балету на льоду і т.д."],
  ["ефіроман", "Людина, що має хворобливу пристрасть оп'яняти себе ефіром."],
  ["марафон", "Змагання з бігу на велику дистанцію (понад 40 км); марафонський біг."],
  ["реформа", "Перетворення, зміна, нововведення, яке не знищує основ існуючої структури."],
  ["амфора", "Велика посудина (для вина, олії та ін.)"],
  ["манера", "Спосіб виконання дії, прийом; звичка діяти певним чином."],
  ["морфін", "Алкалоїд опію, що використовується як наркотичний болезаспокійливий і снотворний засіб."],
  ["фанера", "Деревинний матеріал у вигляді тонких пластин, якими обклеюють столярні вироби для їх оздоблення."],
  ["фараон", "Титул царя в Стародавньому Єгипті."],
  ["ферма", "Приватне капіталістичне сільськогосподарське підприємство на власній або орендованій землі."],
  ["німфа", "У грецькій міфології - божество у вигляді жінки, яке уособлює явища і сили природи."],
  ["афіна", "Давньогрецька богиня, одна з верховних олімпійських божеств."],
  ["номер", "Порядкове число предмета серед інших однорідних."],
  ["форма", "Обриси, контури, зовнішні межі предмета, що визначають його зовнішній вигляд."],
  ["арфа", "Щипковий музичний інструмент, що має форму трикутної рами з натягнутими на ній струнами."],
  ["омар", "Великий морський рак ряду десятиногих, що водиться в Атлантичному океані й ціниться за смачне м'ясо."],
  ["рама", "Віконне дерев'яне сплетіння перев. прямокутної форми з шибками або без них."],
  ["фора", "Наперед обумовлена пільга - якась кількість очок, ходів і т. ін., що її надає сильніший учасник змагань, гри слабшому або такому, який знаходиться у невигідних умовах."],
  ["ера", "Початок літочислення, зв'язаний з якою-небудь історичною або легендарною подією; відповідна система літочислення."],
  ["міф", "Стародавня народна оповідь про явища природи, історичні події тощо або фантастичні оповідання про богів, обожнених героїв, уявних істот."],
  ["українка", "Один із трьох східнослов'янських народів, що нині становить основне населення Української РСР. (жіночий рід)"],
  ["конурка", "Зменш. до конура."],
  ["курочка", " Зменш.-пестл. до курка."],
  ["кокаїн", "Отруйна речовина, яку добувають із листя коки й використовують як місцевий знеболювальний або наркотичний засіб."],
  ["країна", "Територія, що становить єдність із погляду історії, природних умов, населення тощо."],
  ["крона", "Верхня частина дерева, що являє собою сукупність його гілок."],
  ["круча", "Високий стрімкий берег; урвище."],
  ["онука", "Дочка сина або дочки"],
  ["ранок", "Частина доби після ночі, початок, перші години дня."],
  ["чарка", "Велика (перев. скляна) посудина для пиття вина та спиртних напоїв."],
  ["арка", "Склепіння, що має форму дуги, яким перекривають проріз у стіні або сполучають стояни моста, два суміжні будинки і т. ін."],
  ["кнур", "Самець свині."],
  ["кора", "Верхня, здебільшого легко відокремлювана оболонка, що вкриває стебла, гілки, стовбури, коріння рослин."],
  ["кран", "Трубка з затвором, прикріплена до водопроводу, газопроводу чи іншого резервуару для виливання рідини, випускання газу."],
  ["куча", "Те саме, що купа."],
  ["орк", " Римське божество смерті, ототожнюване з грецьким Аїдом; (російський солдат)"],
  ["рак", "Покрита панцером безхребетна прісноводна тварина класу членистоногих з великими клішнями біля голови і черевцем, схожим на хвіст."],
  ["рок", "Узагальнююча назва багатьох напрямків музики."],
  ["чан", "Посудина, що формою нагадує великий бак або діжку."],
  ["чар", "Те саме, що чари"],
]
